import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTenantClass } from '@services/registry';

export function useCreateTenantClass({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload }) => {
            return await createTenantClass({ tenantId, payload });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['tenantClasses', tenantId] });
        },
    });
}

